import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import InitialPageUtil from 'Utils/InitialPageUtil';
import { IS_LOGGED_IN } from 'Utils/PassportUtil';
const HOME_PAGE = '/home';
export default function useStartPage(buttonElement = 'tos_button') {
    const history = useHistory();
    useEffect(() => {
        if (IS_LOGGED_IN) {
            InitialPageUtil.skipStartPageNextTime(buttonElement);
            history.replace(HOME_PAGE);
        }
    }, []);
    const handleClickStart = () => InitialPageUtil.skipStartPageNextTime(buttonElement);
    return { handleClickStart };
}
